import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { showError, showSuccess } from 'utils';
import { createUnit, fetchUnitDetails, updateUnit } from 'services/api/units';

const validationSchema = yup.object().shape({
  description: yup.string().required('Please enter description'),
  enDescription: yup.string(),
});

type FormData = {
  description: string;
  enDescription: string;
};

const CreateUnit = props => {
  const { id } = props.match.params;
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState() as any;

  const {
    register,
    handleSubmit,
    errors,
    setValue,
  } = useForm<FormData>({ resolver: yupResolver(validationSchema) });

  const fetchUnitDetailsFn = async () => {
    setLoading(true);
    try {
      const response = await fetchUnitDetails(id);
      const { description, enDescription } = response;
      setData(response);
      setValue('description', description);
      setValue('enDescription', enDescription);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(id){
      fetchUnitDetailsFn();
    }
  }, []);

  const saveUnitFn = handleSubmit(async (values) => {
    setLoading(true);
    try {
      if(id){
        await updateUnit({ ...values, id: data?.objectId });
        showSuccess('Unit updated successfully.');
        props.history.replace(`/units`);
      } else {
        await createUnit({ ...values });
        showSuccess('Unit created successfully.');
        props.history.goBack();
      }
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  const getHeader = () => {
    const heading = id ? 'Update Unit' : 'Create a New Unit';
    return(
      <div className={styles['header']}>
        <div className={styles['heading']}>{heading}</div>
      </div>
    );
  };

  const getFooter = () => {
    return(
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Save'}
          active={!loading}
          isLoading={loading}
          onClick={saveUnitFn}
        />
      </div>
    );
  };
  
  const getFieldError = (error) => {
    if(!error) return null;
    return(
      <Error message={error} />
    );
  };

  const getDescription = () => {
    return(
      <div className={styles['description']}>
        <div className={styles['label']}>Description*</div>
        <textarea
          name={'description'}
          ref={register}
          className={'form-control'}
          disabled={loading}
        />
        {getFieldError(errors?.description?.message)}
      </div>
    );
  };

  const getEnDescription = () => {
    return(
      <div className={styles['description']}>
        <div className={styles['label']}>English Description</div>
        <textarea
          name={'enDescription'}
          ref={register}
          className={'form-control'}
          disabled={loading}
        />
        {getFieldError(errors?.enDescription?.message)}
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      {getHeader()}
      <div className={styles['sub-container']}>
        {getDescription()}
        {getEnDescription()}
      </div>
      {getFooter()}
    </div>
  );
};

export { CreateUnit };
